import { render, staticRenderFns } from "./ed-portal-tasks.component.vue?vue&type=template&id=346f1744&scoped=true&"
import script from "./ed-portal-tasks.component.ts?vue&type=script&lang=ts&"
export * from "./ed-portal-tasks.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-portal-tasks.component.scss?vue&type=style&index=0&id=346f1744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f1744",
  null
  
)

export default component.exports